export const AssetDimension = {

	Name: "Asset Dimension",

	Libraries: [],

	Events: {

	},

	Actions: {

		"DimensionsByHierarchy": function(dimensionsByHierarchy, data) {

			if (data.DimensionsCreativeId) this.clearCreativeDimensions(data.DimensionsCreativeId);

			_.each(dimensionsByHierarchy, assetDimensions => {
				_.each(assetDimensions, assetDimension => {

					this.setDimension(assetDimension, assetDimension.id, !data.DimensionsCreativeId);

				});
			});

			if (data.DimensionsCreativeId) Broadcast.call("Creative Dimensions Loaded", [data.DimensionsCreativeId]);
			else if (data.DimensionsCreativeId === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Dimensions Loaded");

		},

		"Dimension": function(assetDimension, data) {

			this.setDimension(assetDimension, data.DimensionId); // DimensionId нужен потому что assetDimension может быть null - что означает что объект нужно удалить с клиента

		}

	},

	init() {

		this.Dimensions = {};
		this.DimensionsByHierarchy = {};

	},

	setDimension(assetDimension, dimensionId = null, isBroadcast = true) {

		let oldAssetDimension = this.Dimensions[dimensionId];

		if (assetDimension) {

			this.Dimensions[assetDimension.id] = assetDimension;

			if (!this.DimensionsByHierarchy[assetDimension['creative_id']]) this.DimensionsByHierarchy[assetDimension['creative_id']] = {};
			if (!this.DimensionsByHierarchy[assetDimension['creative_id']][assetDimension['asset_codename']]) this.DimensionsByHierarchy[assetDimension['creative_id']][assetDimension['asset_codename']] = {};
			this.DimensionsByHierarchy[assetDimension['creative_id']][assetDimension['asset_codename']][this.getDimensionKey(assetDimension)] = assetDimension;

		} else if (oldAssetDimension) {

			delete this.Dimensions[oldAssetDimension.id];
			
			if (this.DimensionsByHierarchy[oldAssetDimension['creative_id']][oldAssetDimension['asset_codename']]) delete this.DimensionsByHierarchy[oldAssetDimension['creative_id']][oldAssetDimension['asset_codename']][this.getDimensionKey(oldAssetDimension)];

		}

		if (isBroadcast) {

			let dimensionPrefixes = ["Dimension"];
			if (oldAssetDimension?.["creative_id"] === Creative.SelectedCreative?.id || assetDimension?.["creative_id"] === Creative.SelectedCreative?.id) dimensionPrefixes.push("Selected Creative Dimension");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldAssetDimension, assetDimension, dimensionPrefixes);

		}

	},

	getDimension(creativeId, assetCodename, type, typeId = 0, typeExtras = 'none') {

		return this.DimensionsByHierarchy[creativeId]?.[assetCodename]?.[Asset.getDimensionKeyByData(type, typeId, typeExtras)];

	},
	
	getDimensionKey(assetDimension) {

		return `${assetDimension["type"]}:${assetDimension["type_id"] || 0}:${assetDimension["type_extras"] || 'none'}`;

	},

	getDimensionKeyByData(type, type_id = 0, type_extras = 'none') {

		return `${type}:${type_id || 0}:${type_extras || 'none'}`;

	},

	clearCreativeDimensions(creativeId) {

		_.each(this.Dimensions, assetDimension => {

			if (assetDimension["creative_id"] === creativeId) delete this.Dimensions[assetDimension.id];

		});

	}

};

